interface InfoSectionProps { 
    label?: string
    value?: string | number
    className?: string
    labelClass?: string
}

export const InfoSection:React.FC<InfoSectionProps> = ({ label, value, className, labelClass }) => {
  const parseNegativeNumber = (val?: string | number): number | null | string => {
    if (typeof val === "number") return val;
    if (typeof val !== "string") return null;
    if (val.trim() === "-") return "-";

    const cleanedValue = val.replace(/\./g, "").replace(",", ".");
    const parsedNumber = Number(cleanedValue);

    return isNaN(parsedNumber) ? null : parsedNumber;
  };

  const numericValue = parseNegativeNumber(value);
  const isNegative = numericValue === "-" || (typeof numericValue === "number" && numericValue < 0);

  const valueClass = isNegative ? "text-error" : "";

  return (
    <div className="ml-5">
      <div className={`label-text flex justify-center ${className}`}>
        <div className="w-[150px] text-right">
          <div className={labelClass}>{label ?? ""}</div>
        </div>
        <div className="mx-2 w-[20px] text-center">
          <div>:</div>
        </div>
        <div className="w-[150px]">
          <div className={valueClass}>{value ?? "-"}</div>
        </div>
      </div>
      <hr className="my-1 border-[#3c3c3c]" />
    </div>
  )
}